import { selectLargestIndividualFlightInMergedFlight } from "features/map/inspector-panel/hotspots/mergedFlight.ts/selectors"
import { useAppSelector } from "integrations/redux/hooks"
import { InfraredImageAssetsThumbnail } from "./InfraredImageAssetsThumbnail"

export function MergedFlightAssetsThumbnail({ id }: { id: string }) {
    const largestInfraredFlight = useAppSelector(selectLargestIndividualFlightInMergedFlight(id))
    return <InfraredImageAssetsThumbnail id={largestInfraredFlight?.id || ""} />
}
